import type { FaireProductEntity } from "../../entity_types/product";

export const p_dpdqj2vdc9: FaireProductEntity = {
  token: "p_dpdqj2vdc9",
  type: "product",
  name: "Pique Hot Pepper Sauce",
  brandToken: "b_33v847t70q",
  brandName: "Sol Food",
  imageUrl:
    "https://cdn.faire.com/fastly/0881c83733d5ba65827be36825d294b08a0875a3738d2593e4368e4cbbed4e27.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/dd76e84596e55e57d716891278f7ea4a195319a6698c6c0f19f8e6972d5fbe17.jpeg",
  ],
  priceDollars: 10,
  description:
    "Pique\n\nFamous hot pepper sauce from Sol Food Restaurant in San Rafael, CA. Mild heat.\n\nOur original recipe celebrates traditional Puerto Rician flavors and our special mix of chiles and seasoning. Perfect for a finishing touch to your favorite meal, spicy beverage, cocktail, or marinade. \n\n12 ounce bottle",
  tags: [],
  msrpDollars: 17.99,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-09T05:17:10.272Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
